<template>
  <v-autocomplete
    :items="items"
    v-model="selectedType"
    :label="customLabel || 'Service Type'"
    item-text="name"
    item-value="name"
    @change="changeListener($event)"
    :outlined="outlined"
  ></v-autocomplete>
</template>

<script>
import { ALL_SERVICE_TYPES_QUERY } from "../../../constants/graphql";
import { removeGQLTypename } from "../../../helpers";
export default {
  name: "ServiceTypeListSelect",

  props: {
    customLabel: { type: String },
    serviceTypeName: { type: String, default: () => "" },
    supplierType: { type: String },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      serviceTypes: {},
      selectedType: this.value != "" ? this.value : this.serviceTypeName,
    };
  },

  computed: {
    items() {
      return this.serviceTypes && this.serviceTypes.edges
        ? this.serviceTypes.edges.map(removeGQLTypename).filter((item) => {
            return this.serviceTypeName != ""
              ? item.name == this.serviceTypeName || !item.notInUse
              : !item.notInUse;
          })
        : [];
    },
  },

  apollo: {
    serviceTypes: {
      query: ALL_SERVICE_TYPES_QUERY,
      variables() {
        return {
          supplierType: this.supplierType,
        };
      },

      skip() {
        //console.log('skip check', this.supplierType);
        return this.supplierType == undefined || this.supplierType == "";
      },
    },
  },

  methods: {
    changeListener(data) {
      if (typeof data == "string") {
        var selectedItem = this.items.find((item) => item.name == data);
        //console.log('selected item', selectedItem);
        if (selectedItem) {
          this.$emit("onSelect", selectedItem);
          this.$emit("input", selectedItem.name);
        }
      }
    },
  },
  watch: {
    serviceTypeName: function () {
      this.selectedType = this.serviceTypeName;
    },
    value(newVal) {
      this.selectedType = newVal;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ServiceTypeListSelect.vue